import { render, staticRenderFns } from "./PriceUCB.vue?vue&type=template&id=1b078bbe&scoped=true"
import script from "./PriceUCB.vue?vue&type=script&lang=js"
export * from "./PriceUCB.vue?vue&type=script&lang=js"
import style0 from "./PriceUCB.vue?vue&type=style&index=0&id=1b078bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b078bbe",
  null
  
)

export default component.exports